/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ChildAddressModel } from './childAddressModel';
import { ChildEmployerGroupsConfig } from './childEmployerGroupsConfig';
import { ChildEmployerWorkPlaceModel } from './childEmployerWorkPlaceModel';
import { ChildEmployerEmailDomain } from './childEmployerEmailDomain';
import { ChildOrganizationSizeModel } from './childOrganizationSizeModel';
import { TripModeEnum } from './tripModeEnum';
import { ChildEmployerTripLogConfig } from './childEmployerTripLogConfig';


export interface ApiRequestUpdateEmployer { 
    possibleCommuteModes: Array<TripModeEnum>;
    id: string;
    name: string;
    email: string;
    phoneNumber?: string;
    workPlaces: Array<ChildEmployerWorkPlaceModel>;
    employerGroupsConfig?: ChildEmployerGroupsConfig;
    emailDomains: Array<ChildEmployerEmailDomain>;
    isPublic: boolean;
    organizationSize?: ChildOrganizationSizeModel;
    address: ChildAddressModel | null;
    connectCode?: string;
    tripLogConfig: ChildEmployerTripLogConfig;
    locale: string;
}

